import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { useApiFormPublishAsset, useApiListPublishAsset } from '../../../../../../api-new/state/content'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { IconList } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { Purge } from '../../../../../../shared/page/page-purge'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const PublishAssetListRecycle = () => {
  const { url } = useRouteMatch()

  const { nodeID } = useParamsInt()

  const apiListPublishAsset = useApiListPublishAsset()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListPublishAsset.get(`${nodeID}/deleted-parent`)
  const handleDestroyed = () => apiListPublishAsset.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListPublishAsset.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That published asset was already removed.'), err)
    }
    await apiListPublishAsset.get(`${nodeID}/deleted-parent`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle">
        <CardFullHeightScrollY title="recycle">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListPublishAsset} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnDateTime field="createdAt" />
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/purge/${row.id}`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/purge/:purgeID`}>
        <Purge useApiForm={useApiFormPublishAsset} titleParam="name" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
